<template>
<!-- Iframes: mit Tabs -->
<div class="etx-container Container" :class="paragraphClassList">
	<div class="etx-center Center">
		
		<div class="Tabs">

      <div class="Tabs__header" :class="entranceClassList">

        <div v-for="(element, index) in elements" :key="index" class="Tabs__header__item" :class="{ active: activeTab === index }" @click="activeTab = index" :data-tab-id="'iframe-standard-' + index">
          
          <span v-text="element.title" />

        </div>

      </div>

      <div class="Tabs__content">
        
        <div v-for="(element, index) in elements" :key="index" class="Tabs__content__item" :class="{ active: activeTab === index }" :data-tab-id="'iframe-standard-' + index">
          
          <div class="Iframe" :class="entranceClassList" v-html="element.code" />
				    
        </div>
      
      </div>

    </div>
		
	</div>
</div>
</template>

<script lang="ts" setup>
type TabElement = {
  title: string
  code: string
}

defineProps<{
  elements: Array<TabElement>
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'iframe_tabs',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const activeTab = ref(0);

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})
</script>
